export class CssAnimation 
{
	static get EVENTS()
	{
		return {
			ANIMATION_END: 'animationend',
			TRANSITION_END: 'transitionend'
		};
	}

	static hasAnimation(target)
	{
		return !!parseFloat(window.getComputedStyle(target).animationDuration || 0);
	}

	static hasTransition(target)
	{
		return !!parseFloat(window.getComputedStyle(target).transitionDuration || 0);
	}

	static trigger(target, event, className, deleteAfterComplete = false)
	{
		return new Promise((resolve, reject) => {
			target.classList.add(className);
			if (
				(event === this.EVENTS.ANIMATION_END && !this.hasAnimation(target)) ||
				(event === this.EVENTS.TRANSITON_END && !this.hasTransition(target))
			)
				resolve(false);

			const handle = () => {
				target.removeEventListener(event, handle);
				if (deleteAfterComplete)
					target.classList.remove(className);
				resolve(true);
			};

			target.addEventListener(event, handle);
		});
	}

	static triggerTransition(target, className, deleteAfterComplete = false)
	{
		return this.trigger(
			target,
			this.EVENTS.TRANSITION_END, 
			className, 
			deleteAfterComplete
		)
	}

	static triggerAnimation(target, className, deleteAfterComplete = true)
	{
		return this.trigger(
			target,
			this.EVENTS.ANIMATION_END, 
			className, 
			deleteAfterComplete
		)
	}
}